{
  "process-container": {
    "text": {
      "back-to-home": "Quay lại trang chủ",
      "page-loading": "Đang tải trang"
    }
  }
}
